import { render, staticRenderFns } from "./AddContainersDialog.vue?vue&type=template&id=38cb94f2"
import script from "./AddContainersDialog.vue?vue&type=script&lang=js"
export * from "./AddContainersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports